import './assets/css/index.less';
import StdSimulatorPreview from './components/SimulatorPreview.vue';
import StdEditor from './components/Tinymce/index.vue';
import StdPageContainer from './components/PageContainer.vue';
import StdPageForm from './components/PageForm.vue';
import StdPageTitle from './components/PageTitle.vue';
import { StdSplitpane, StdPane } from './components/SplitPane/index.js';
import StdSearchBar from './components/SearchBar.vue';
import StdStatusText from './components/StatusText.vue';
import StdNullPage from './components/NullPage.vue';
import StdPagination from './components/Spagination.vue';
import StdBackHeader from './components/BackHeader.vue';
import StdDialog from './components/StdDialog.vue';
import * as filters from './tools/filter';
import './tools/directives.js';

const components = [
  StdSimulatorPreview,
  StdEditor,
  StdPageContainer,
  StdPageForm,
  StdPageTitle,
  StdSplitpane,
  StdPane,
  StdSearchBar,
  StdStatusText,
  StdNullPage,
  StdPagination,
  StdBackHeader,
  StdDialog
];
// install 方法提供给Vue.use()全局引入
const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });

  // 过滤器
  Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]); //插入过滤器名和对应方法
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export * from './tools/utils.js';
export * from './mixins/index.js';

export default {
  filters,
  StdSimulatorPreview,
  StdEditor,
  StdPageContainer,
  StdPageForm,
  StdPageTitle,
  StdSplitpane,
  StdPane,
  StdSearchBar,
  StdStatusText,
  StdNullPage,
  StdPagination,
  StdBackHeader,
  StdDialog
};

export {
  filters,
  StdSimulatorPreview,
  StdEditor,
  StdPageContainer,
  StdPageForm,
  StdPageTitle,
  StdSplitpane,
  StdPane,
  StdSearchBar,
  StdStatusText,
  StdNullPage,
  StdPagination,
  StdBackHeader,
  StdDialog
};
